module.exports = __webpack_public_path__ + "static/media/ic-search-dark.e1e5a22c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-search-dark.svg
// module id = 786
// module chunks = 0